<ul class="flex items-center justify-center">
    <li (click)="onPageChange((currentPage - 1).toString())"
        class="flex items-center justify-center rounded-lg text-[#16181B] cursor-pointer ml-4">
        <i class="ico-ArrowRight ml-2" (click)="onPageChange((currentPage - 1).toString())"></i>
        <span class="hidden lg:block">قبلی</span>
    </li>
    <li (click)="onPageChange(item)" [ngClass]="{
   'bg-[#F9FAFB] !text-[#1F2937] !cursor-default': currentPage === +item,
   '!cursor-default': item === '...'
  }" *ngFor="let item of this.pages"
        class="w-10 h-10 flex items-center justify-center rounded-lg text-[#777A80] cursor-pointer">
        {{ item }}
    </li>

    <li (click)="onPageChange((currentPage + 1).toString())"
        class="flex items-center justify-center rounded-lg text-[#16181B] cursor-pointer mr-4 ">
        <span class="hidden lg:block">بعدی</span>
        <i class="ico-ArrowLeft mr-2" (click)="onPageChange((currentPage + 1).toString())"></i>
    </li>
</ul>